import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-admin-nav',
  templateUrl: './admin-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminNavComponent {
}
